import './Balance.css';
import { Button } from '../../../buttons/Button/Button';

const text = '150.00';
const buttonText = 'RUB';
export const Balance = () => {
    return (
        <div className="header__balance">
            <Button buttonText={buttonText} />
            <div className="header__balance-button">
                <svg className="header__wallet" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                    <g fill="none" opacity=".6">
                        <path fill="#605F68" d="M17.88 20.88h-12a3 3 0 0 1-3-3v-12h15a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3z" />
                        <circle cx="17.38" cy="13.38" r="1.5" fill="#F1F1F1" />
                        <path fill="#F1F1F1" d="M2.88 5.88a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3h-15z" />
                    </g>
                </svg>
                <span className="header__balance-text">{text}</span>
                <svg className="header__add-button" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                    <g fill="none" opacity=".6">
                        <circle cx="7.947" cy="7.947" r="6.667" fill="#605F68" />
                        <path
                            fill="#F1F1F1"
                            d="M11.28 7.28h-2a.667.667 0 0 1-.667-.667v-2a.667.667 0 0 0-1.333 0v2a.667.667 0 0 1-.667.667h-2a.667.667 0 0 0 0 1.333h2c.368 0 .667.299.667.667v2a.667.667 0 0 0 1.333 0v-2c0-.368.299-.667.667-.667h2a.667.667 0 0 0 0-1.333z"
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};
